import { __spreadArrays } from "tslib";
import * as React from 'react';
import { isNullOrUndefined } from 'util';
/**
 * A version of useToggleState that allows for management of an array of togglable states index by a key.
 *
 * @param initialState
 */
export function useToggleStateArray(initialState) {
    var _a = React.useState(initialState !== null && initialState !== void 0 ? initialState : []), state = _a[0], setState = _a[1];
    var getState = React.useCallback(function (key) {
        return !!state.find(function (it) { return it === key; });
    }, [state]);
    var toggle = React.useCallback(function (key, value) {
        setState(function (prevState) {
            var currentValue = prevState.find(function (it) { return it === key; });
            // Set an explicit value.
            if (!isNullOrUndefined(value)) {
                var newValue = value;
                if (value instanceof Function) {
                    newValue = value(!!currentValue);
                }
                if (newValue) {
                    return __spreadArrays(prevState.filter(function (it) { return it !== key; }), [key]);
                }
                else {
                    return prevState.filter(function (it) { return it !== key; });
                }
            }
            // Toggle the state based on its current value.
            if (isNullOrUndefined(currentValue)) {
                return __spreadArrays(prevState, [key]);
            }
            else {
                return prevState.filter(function (it) { return it !== key; });
            }
        });
    }, [setState]);
    return [getState, toggle];
}
//# sourceMappingURL=useToggleStateArray.js.map